define('viewModels/privileged/qm/ChatDetailsView',[
    'jquery',
    'moment',
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'viewModels/ViewModel'
], function ($,
             moment,
             ko,
             _,
             Promise,
             ViewModel) {
    'use strict';

    return ViewModel.extend(function (chatTranscript) {
        var self = this;
        var chat = ko.observable(chatTranscript);
        self.chatMessages = ko.observableArray();
        self.isLoading = ko.observable(false);

        var isGuest = function (personChatId) {
            return (personChatId.match('@conference.guest') || personChatId.match('@guest'));
        };

        var isAgent = function(personChatId) {
            return (personChatId.match('orgspan.com'));
        };

        var isSystem = function(personChatId) {
            return personChatId === "System";
        };

        var isWorkflowParticipant = function(participantPurpose) {
            return (participantPurpose.match('workflow'));
        };

        var isCustomerParticipant = function(participantPurpose) {
            return (participantPurpose.match('customer'));
        };

        if (chat()) {
            // Get all chats with standard body type (or no body type, for v1 compatability)
            var standardBodyChats = _.filter(chat(), function (chatMessage) {
                chatMessage.isStandard = !chatMessage.bodyType || chatMessage.bodyType === "STANDARD";
                chatMessage.isNotice = chatMessage.bodyType === "NOTICE";
                return chatMessage.isStandard || chatMessage.isNotice;
            });

            self.chatMessages(_.map(standardBodyChats, function (chatMessage) {
                var defaultMessage = {
                    userInfo: ko.observable({
                        id: ko.observable(chatMessage.user ? chatMessage.user.id : ''),
                        isSelf: ko.observable(false)
                    })
                };

                var decoratedMessage = ko.observable(_.assign(defaultMessage, chatMessage));

                decoratedMessage().time = function() {
                    return moment(decoratedMessage().utc).toDate();
                };

                var fromUser = decoratedMessage().from;
                if (!fromUser) {
                    var participantPurpose = decoratedMessage().participantPurpose;
                    if (participantPurpose && isWorkflowParticipant(participantPurpose)) {
                        decoratedMessage().userInfo().name = ko.observable(ko.i18n.renderString('conversationDetails.participantName.workflow'));
                    } else if (participantPurpose && isCustomerParticipant(participantPurpose)) {
                        decoratedMessage().userInfo().name = ko.observable(ko.i18n.renderString('conversationDetails.participantName.customer'));
                    } else {
                        decoratedMessage().userInfo().name = ko.observable(ko.i18n.renderString('conversationDetails.participantName.unknown'));
                    }
                } else if (isGuest(fromUser)) {
                    decoratedMessage().userInfo().name = ko.observable(ko.i18n.renderString('chat.guest.name'));
                }
                else if (chatMessage.user) {
                    decoratedMessage().userInfo().name = ko.observable(chatMessage.user.name);
                }
                else if (isSystem(fromUser)) {
                    decoratedMessage().userInfo().name = ko.observable(ko.i18n.renderString('conversationDetails.participantName.system'));
                }
                else if (!isAgent(fromUser)) {
                    decoratedMessage().userInfo().name = ko.observable(fromUser);
                }
                else {
                    decoratedMessage().userInfo().name = ko.observable(ko.i18n.renderString('chat.agent.name'));
                }
                return decoratedMessage;
            }));
        }
    });
});

